import React from 'react';
import { Home, BarChart3, BookOpen, Gamepad2 } from 'lucide-react';
import { playSound } from '../../utils/soundManager';
import { useLanguage } from '../../contexts/LanguageContext';

const Navigation = ({ currentView, setCurrentView, goHome }) => {
  const { t } = useLanguage();
  
  const handleNavClick = (view) => {
    playSound('click');
    if (view === 'home') {
      goHome();
    } else {
      setCurrentView(view);
    }
  };

  return (
    <nav className="navigation">
      <button
        className={`nav-button hover-lift ${currentView === 'home' ? 'active' : ''}`}
        onClick={() => handleNavClick('home')}
      >
        <Home size={20} />
        <span>{t('nav.home')}</span>
      </button>
      
      <button
        className={`nav-button hover-lift ${currentView === 'gamezone' ? 'active' : ''}`}
        onClick={() => handleNavClick('gamezone')}
      >
        <Gamepad2 size={20} />
        <span>{t('nav.gameZone')}</span>
      </button>
      
      <button
        className={`nav-button hover-lift ${currentView === 'dashboard' ? 'active' : ''}`}
        onClick={() => handleNavClick('dashboard')}
      >
        <BarChart3 size={20} />
        <span>{t('nav.dashboard')}</span>
      </button>
    </nav>
  );
};

export default Navigation;
